import React from 'react';
const STATS: Array<{
  valor: string;
  label: string;
}> = [{
  valor: '633',
  label: 'páginas'
}, {
  valor: '400',
  label: 'actividades'
}, {
  valor: '6 + 6',
  label: 'tomos y bonos'
}, {
  valor: '21',
  label: 'días de plan'
}];
export function StatsStrip() {
  return <section className="bg-coral text-white py-8 px-5" aria-label="El kit en números" data-id="element-262" data-mp="2i7oiyntvd2rx">
      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-263" data-mp="2i5tw33z1f0l7">
        {STATS.map(stat => <div key={stat.label} data-id="element-264" data-mp="1pj95w6uasuj8">
            <div className="font-serif text-3xl sm:text-4xl font-bold leading-none" data-id="element-265" data-mp="1pkagka7ejf0f">{stat.valor}</div>
            <div className="mt-1 text-xs sm:text-sm uppercase tracking-widest text-white/85" data-id="element-266" data-mp="23b76tuduvk4b">
              {stat.label}
            </div>
          </div>)}
      </div>
    </section>;
}